module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_9.a7a528db.jpg";